import type { FaireProductEntity } from "../../entity_types/product";

export const p_clrijyjxg2: FaireProductEntity = {
  token: "p_clrijyjxg2",
  type: "product",
  name: "Original Masala Soul Chai Powder",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl:
    "https://cdn.faire.com/fastly/63a01ec4ea3a97be69164ad6ecba5870962bf587d9f84188a8bf432267951735.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a65431d8a59ed787b34501fce5496f4fcc16b6a76fc90134913180129392868e.jpeg",
    "https://cdn.faire.com/fastly/797a328cdc0dd60d96194e304ac9960df0c6b268a2bea759f3f8bea5edb12a5d.png",
    "https://cdn.faire.com/fastly/ad11b02e2c171b48ff4aa9251e61042f6436ba5b33d840377941b08960bdc7de.png",
    "https://cdn.faire.com/fastly/53de0fdc085348ce9f5a64b1fd353c3012c3a100307faeebf54e167703bb91d2.jpeg",
    "https://cdn.faire.com/fastly/f6646f03eb3b31e761e5ca75fb96205ee55a4d2e152df82ff4b6345323f9db99.png",
    "https://cdn.faire.com/fastly/0748a307e13083d9a090cab1e862579d74ee7d1c12b567731ad7561ae0ff403e.jpeg",
    "https://cdn.faire.com/fastly/8d1f294810aeb848bf819265cb192d286a5bdf1b0a926011acece3a1fbfc7554.jpeg",
    "https://cdn.faire.com/fastly/ddc7976c7a2c346384a98ca21555df9d42c3c3b9519652dccf54f70158188000.jpeg",
  ],
  priceDollars: 13,
  description:
    "Our original, black tea masala chai is bold, spicy-sweet & soul-warming. The stuff your mugs dream about when they sleep in your cupboards at night! No sweeteners or preservatives, just fresh tea + spices~\n\nStrainer-free and ready in under a minute: scoop a teaspoon of chai powder into your favorite mug, add a dash of 205+ water, fill the rest of your mug with steamed milk, sweeten to your liking, add a pinch of salt on top & Enjoy!\n\nVegan & gluten-free.\n\nIngredients: Assam tea, organic spices: ginger, cardamom, cinnamon, black pepper, cloves.",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:49.880Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
